import { baseURL } from '../../constants/baseURL';
import { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { axiosInstance } from '../../constants/axiosInstance';
import { Loader } from './Loader'
import { useNavigate, useLocation } from 'react-router';
import { useAlert } from 'react-alert';
import Reviews from '../major-components/Reviews';
import { X, Star, ShoppingCart } from 'lucide-react';


export const SingleProductDetails = (props) => {

    const [loading, setLoading] = useState(false);
    const [price, setPrice] = useState(props.item.price);
    const [selectedProductName, setSelectedProductName] = useState('');
    const [showReviews, setShowReviews] = useState(false);
    const alert = useAlert();
    const navigate = useNavigate();
    const location = useLocation();

    const handleClose = () => {
        const context = JSON.parse(localStorage.getItem('productModalContext'));
        props.modal(false); // Close the modal
        localStorage.removeItem('productModalContext');
    };

    const addToCart = async (item, qty, price, selectedProductName, shopName) => {
        let extras = [];

        if (price && selectedProductName !== '') {
            let obj = {
                productName: selectedProductName,
                cost: price,
                shopName: shopName,
                quantity: 1
            };
            extras.push(obj);
        }
        const details = {
            productId: item,
            quantity: qty,
            shopName: shopName,
            extras: extras
        };

        if (localStorage.getItem('token') == null) {
            alert.show("Sign in Your Account first");
            navigate('/login');
        } else {
            axiosInstance.post('/api/v1/order/addtocart', details, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": localStorage.getItem('token')
                }
            }).then((res) => {
                localStorage.setItem('totalCart', res.data.data.details.length);
                alert.show("Product Added to Cart");

                if (props.setSearchQuery) { // Check if setSearchQuery exists
                    props.setSearchQuery(!props.searchQuery);
                }
            }).catch((err) => {
                alert.show("Something went wrong");
            });
        }
    };

      const handlePrice = (e) => {
        setPrice(e.target.value);
        var index = e.nativeEvent.target.selectedIndex;
        setSelectedProductName(e.nativeEvent.target[index].text);
    };

    const EffectBar = ({ label, value }) => (
        <div className="mb-4">
            <div className="flex justify-between items-center mb-1">
                <p className="text-sm font-medium text-gray-700">{label}</p>
                <span className="text-sm font-medium text-gray-600">{value}%</span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2">
                <div 
                    className="bg-[#E36666] h-2 rounded-full transition-all duration-300 ease-in-out" 
                    style={{ width: `${value}%` }}
                />
            </div>
        </div>
    );

    // Add animation styles
    const modalStyles = `
        @keyframes modal-slide-up {
            from {
                opacity: 0;
                transform: translateY(20px);
            }
            to {
                opacity: 1;
                transform: translateY(0);
            }
        }
        .animate-modal-slide-up {
            animation: modal-slide-up 0.3s ease-out forwards;
        }
    `;

    return (
        <>
            <style>{modalStyles}</style>
            {!loading ? (
                <div className="bg-gray-50 py-4">
                    <div className="max-w-7xl mx-auto px-4">
                        <div className="bg-white rounded-xl shadow-sm overflow-hidden max-h-[80vh] overflow-y-auto relative">
                            {/* Sticky Header with Close Button */}
                            <div className="sticky top-0 z-10 border-b border-gray-200 bg-[#E9DCB0] p-6">
                                <div className="flex items-start justify-between">
                                    <div className="flex-1">
                                        <h1 className="text-2xl font-bold text-gray-800 tracking-tight">
                                            {props.item.name}
                                        </h1>
                                        <div className="mt-2">
                                            <span className="inline-flex items-center px-3 py-1 text-sm font-medium bg-white/80 text-gray-700 rounded-md border border-gray-200 shadow-sm">
                                                {props.item.type}
                                            </span>
                                        </div>
                                    </div>
                                    {/* Updated Close Button */}
                                    <button
            onClick={handleClose}
            className="p-1.5 rounded-md bg-white hover:bg-red-100 transition-colors duration-200 border border-gray-200 group"
        >
            <X 
                className="w-4 h-4 text-gray-600 group-hover:text-red-600 stroke-2" 
            />
        </button>
                                </div>
                            </div>

                            {/* Main Content */}
                            <div className="grid md:grid-cols-2 gap-8 p-6">
                                {/* Left Column - Image and Purchase */}
                                <div className="space-y-6">
                                    <div className="aspect-square rounded-lg overflow-hidden border border-gray-200">
                                        <img 
                                            src={`${baseURL}${props.item.productPhoto}`}
                                            alt={props.item.name}
                                            className="w-full h-full object-cover"
                                        />
                                    </div>

                                    {/* Purchase Options */}
                                    <div className="space-y-4">
                                        {props.item.extras.length > 0 && (
                                            <select 
                                                onChange={handlePrice}
                                                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#E9DCB0] focus:border-transparent"
                                            >
                                                <option hidden>Select Option</option>
                                                {props.item.extras.map((extra, index) => (
                                                    <option 
                                                        key={index} 
                                                        value={eval(`extra.extras${index + 1}?.cost`)}
                                                    >
                                                        {eval(`extra.extras${index + 1}?.productName`)} - (${eval(`extra.extras${index + 1}?.cost`)})
                                                    </option>
                                                ))}
                                            </select>
                                        )}

                                        <button 
                                            onClick={() => addToCart(props.item._id, 1, price, selectedProductName, localStorage.getItem('shopName'))}
                                            className="w-full py-3 px-4 bg-[#E9C95D] hover:bg-[#E9B54D] text-gray-900 rounded-lg transition-colors duration-200 flex items-center justify-between"
                                        >
                                            <FontAwesomeIcon className="w-5 h-5" icon="fa-solid fa-cart-shopping" />
                                            <span className="font-medium">Add to Cart</span>
                                            <span className="font-medium">${price}</span>
                                        </button>
                                    </div>
                                </div>

                                {/* Right Column - Details and Effects */}
                                <div className="space-y-8">
                                    {/* Description */}
                                    <div>
                                        <h2 className="text-lg font-semibold text-gray-900 mb-3">Description</h2>
                                        <p className="text-gray-600">{props.item.description}</p>
                                    </div>

                                    {/* Effects */}
                                    <div>
                                        <h2 className="text-lg font-semibold text-gray-900 mb-4">Effects</h2>
                                        <div className="space-y-2">
                                            <EffectBar label="Uplifted" value={props.item.effects.uplifted} />
                                            <EffectBar label="Euphoric" value={props.item.effects.euphoric} />
                                            <EffectBar label="Energetic" value={props.item.effects.energetic} />
                                            <EffectBar label="Creative" value={props.item.effects.creative} />
                                            <EffectBar label="Focused" value={props.item.effects.focused} />
                                        </div>
                                    </div>

                                    {/* Levels */}
                                    <div>
                                        <h2 className="text-lg font-semibold text-gray-900 mb-4">Levels</h2>
                                        <div className="space-y-2">
                                            <EffectBar label="THC Level" value={props.item.effects.thc} />
                                            <EffectBar label="CBD Level" value={props.item.effects.cbd} />
                                        </div>
                                    </div>

                                    {/* Reviews Button */}
                                    <button
                                        onClick={() => setShowReviews(true)}
                                        className="w-full py-2 px-4 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg transition-colors duration-200 flex items-center justify-center gap-2"
                                    >
                                        <FontAwesomeIcon icon="fa-solid fa-star" className="w-4 h-4" />
                                        <span>Show Reviews</span>
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* Reviews Modal */}
                        {showReviews && (
                            <div className="fixed inset-0 z-50 overflow-y-auto">
                                <div 
                                    className="fixed inset-0 bg-black bg-opacity-50 transition-opacity duration-300"
                                    onClick={() => setShowReviews(false)}
                                />
                                
                                <div className="flex items-center justify-center min-h-screen px-4 py-6 sm:p-0">
                                    <div className="relative bg-white rounded-xl shadow-xl w-full max-w-2xl m-4 animate-modal-slide-up">
                                        {/* Modal Header with Smaller Close Button */}
                                        <div className="flex items-center justify-between p-4 border-b bg-[#E9DCB0]">
                                            <h3 className="text-lg font-semibold text-gray-800">Product Reviews</h3>
                                            {/* Smaller Close Button for Modal */}
                                            <button
                                                onClick={() => setShowReviews(false)}
                                                className="p-1.5 rounded-md bg-white hover:bg-red-100 transition-colors duration-200 border border-gray-200 group"
                                            >
                                                <X 
                                                    className="w-4 h-4 text-gray-600 group-hover:text-red-600 stroke-2" 
                                                />
                                            </button>
                                        </div>
                                        
                                        <div className="p-6 max-h-[60vh] overflow-y-auto">
                                            <Reviews 
                                                productId={props.item._id}
                                                orderId={props.orderId}
                                                isHomePage={false}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            ) : (
                <Loader />
            )}
        </>
    );
};